import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, ChevronLeft, ChevronRight } from 'lucide-react';
const scrollToCheckout = () => {
  const checkoutButton = document.getElementById('checkout-button');
  if (checkoutButton) {
    checkoutButton.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }
};
const previewImages = ['https://cdn.magicpatterns.com/uploads/nYZ9tTRrxqirEhmeY8APsy/Captura_de_pantalla_2026-01-03_a_la(s)_9.55.48_p._m..png', 'https://cdn.magicpatterns.com/uploads/fDyDH3U36vbNXvmkzJJpB1/Captura_de_pantalla_2026-01-03_a_la(s)_9.55.55_p._m..png', 'https://cdn.magicpatterns.com/uploads/quVWJ4oXHz16JwpQohwEva/Captura_de_pantalla_2026-01-03_a_la(s)_9.56.07_p._m..png', 'https://cdn.magicpatterns.com/uploads/8fCGTEpJV6Vbd2HY2dKgj1/Captura_de_pantalla_2026-01-03_a_la(s)_9.56.14_p._m..png'];
export function ContentPreview() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const nextSlide = () => {
    setCurrentIndex(prev => (prev + 1) % previewImages.length);
  };
  const prevSlide = () => {
    setCurrentIndex(prev => (prev - 1 + previewImages.length) % previewImages.length);
  };
  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };
  return <section className="py-20 bg-gray-50" data-id="element-44">
      <div className="container mx-auto px-4 text-center" data-id="element-45">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-46">
          Mirá el contenido por dentro
        </h2>
        <p className="text-gray-600 mb-12 max-w-2xl mx-auto" data-id="element-47">
          Explorá algunas páginas del material para ver la calidad y
          organización profesional que recibirás
        </p>

        {/* Carousel Container */}
        <div className="max-w-4xl mx-auto mb-12" data-id="element-48">
          <div className="relative" data-id="element-49">
            {/* Main Image Display */}
            <div className="relative aspect-[3/4] md:aspect-[16/10] bg-white rounded-2xl shadow-2xl overflow-hidden" data-id="element-50">
              <AnimatePresence mode="wait" data-id="element-51">
                <motion.img key={currentIndex} src={previewImages[currentIndex]} alt={`Vista previa del material - Página ${currentIndex + 1}`} initial={{
                opacity: 0,
                x: 100
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: -100
              }} transition={{
                duration: 0.3
              }} className="w-full h-full object-contain" data-id="element-52" />
              </AnimatePresence>

              {/* Navigation Arrows */}
              <button onClick={prevSlide} className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 p-3 rounded-full shadow-lg transition-all hover:scale-110" aria-label="Imagen anterior" data-id="element-53">
                <ChevronLeft className="w-6 h-6" data-id="element-54" />
              </button>
              <button onClick={nextSlide} className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 p-3 rounded-full shadow-lg transition-all hover:scale-110" aria-label="Siguiente imagen" data-id="element-55">
                <ChevronRight className="w-6 h-6" data-id="element-56" />
              </button>

              {/* Image Counter */}
              <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-gray-900/80 text-white px-4 py-2 rounded-full text-sm font-medium" data-id="element-57">
                {currentIndex + 1} / {previewImages.length}
              </div>
            </div>

            {/* Thumbnail Navigation */}
            <div className="flex justify-center gap-3 mt-6" data-id="element-58">
              {previewImages.map((image, index) => <button key={index} onClick={() => goToSlide(index)} className={`relative w-20 h-24 rounded-lg overflow-hidden border-2 transition-all ${index === currentIndex ? 'border-blue-600 scale-105 shadow-lg' : 'border-gray-300 opacity-60 hover:opacity-100 hover:border-blue-400'}`} data-id="element-59">
                  <img src={image} alt={`Miniatura ${index + 1}`} className="w-full h-full object-cover" data-id="element-60" />
                  {index === currentIndex && <div className="absolute inset-0 bg-blue-600/20" data-id="element-61"></div>}
                </button>)}
            </div>
          </div>
        </div>

        <motion.button onClick={scrollToCheckout} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="inline-flex items-center gap-2 bg-blue-600 text-white font-bold py-3 px-8 rounded-full shadow-lg hover:bg-blue-700 transition-colors cursor-pointer" data-id="element-62">
          QUIERO ACCEDER AL MATERIAL COMPLETO
          <ArrowRight className="w-5 h-5" data-id="element-63" />
        </motion.button>
      </div>
    </section>;
}